<app-content-control *ngIf="controls" [contentControls]="controls"></app-content-control>
